import React from "react"
import PropTypes from "prop-types"


const ImageCols = ({ children }) => {
  return(
      <div className="contained flex center" id="image-cols">{children}</div>
  );
}

ImageCols.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ImageCols
